import styled from "styled-components";
import { BOX_SHADOW } from "@/constants/colors";

export const DashboardIFrame = styled.iframe`
  border: none;
  box-shadow: 0 0 5px 0 ${BOX_SHADOW};
  display: none;
`;
